import EditableDataTable from '../components/EditableDataTable';
import React, { useState, useEffect } from 'react';
import * as api from '../services/api';
import SharePointUpload from '../components/SharePointUpload';

export default function BoardMeetings({ showToast, editMode }) {
  const [tab, setTab] = useState('register');
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMeetingForm, setShowMeetingForm] = useState(false);
  const [meetingForm, setMeetingForm] = useState({ type:'board_meeting', date:'', venue:'', chair:'Akanimo Udofia' });
  const [selectedMeeting, setSelectedMeeting] = useState(null);
  const [resolutions, setResolutions] = useState([]);

  // Resolution builder state
  const [res, setRes] = useState({
    ref:'', mtype:'Board Meeting', date:'', venue:'', members:'1. Mr. Akanimo Udofia, Managing Director\n2. Tomy John, Deputy Managing Director\n3. Mr. Asuquo Stephen Udofia, Director\n4. Mr. Ubong Udofia, Director\n5. Asuquo Idongesit Udofia, Director\n6. Mrs. Asuquo Emem Udofia, Director\n7. Mr. Umoh E. Bassey, Director\n8. Aniekan Alexis Udofia, Director',
    title:'', body:'', items:'', chair:'Akanimo Udofia', sec:'Eyitemi Sule'
  });

  useEffect(() => { loadMeetings(); }, []);

  async function loadMeetings() {
    try { const { data } = await api.getMeetings(); setMeetings(data || []); }
    catch (err) { showToast('Failed to load meetings'); }
    finally { setLoading(false); }
  }

  async function submitMeeting() {
    try { await api.createMeeting(meetingForm); showToast('Meeting registered'); setShowMeetingForm(false); loadMeetings(); }
    catch (err) { showToast('Registration failed'); }
  }

  async function loadResolutions(meetingId) {
    try { const { data } = await api.getResolutions(meetingId); setResolutions(data || []); setSelectedMeeting(meetingId); }
    catch (err) { showToast('Failed to load resolutions'); }
  }

  async function saveResolution() {
    if (!selectedMeeting) { showToast('Select a meeting first'); return; }
    if (!res.ref) { showToast('Enter a Resolution Reference'); return; }
    try {
      await api.createResolution(selectedMeeting, {
        ref: res.ref, title: res.title, body: res.body,
        resolution_items: res.items, members_present: res.members,
        chair_name: res.chair, secretary_name: res.sec
      });
      showToast('Resolution ' + res.ref + ' saved');
      loadResolutions(selectedMeeting);
    } catch (err) { showToast('Save failed'); }
  }

  function printResolution() {
    const preview = document.getElementById('res-preview-content');
    if (!preview) return;
    const win = window.open('', '_blank');
    win.document.write('<html><head><title>Board Resolution</title><style>body{font-family:Georgia,serif;max-width:700px;margin:40px auto;font-size:13px;line-height:1.8;color:#1a1a1a;} @media print{body{margin:20px;}}</style></head><body>');
    win.document.write(preview.innerHTML);
    win.document.write('</body></html>');
    win.document.close();
    win.print();
  }

  const formatDate = (d) => d ? new Date(d+'T12:00:00').toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'}) : '______ 2025';

  const minutesStatusBadge = (s) => {
    const c = { draft:'badge-gold', pending_approval:'badge-gold', approved:'badge-green' };
    return <span className={`badge ${c[s]||'badge-gray'}`}>{s?.replace(/_/g,' ')}</span>;
  };

  const TABS = [
    { id:'register', label:'Meeting Register' },
    { id:'resolution', label:'Resolution Builder' },
    { id:'minutes', label:'Minutes Repository' },
  ];

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div>
      <div className="section-header"><div className="section-title">🏛️ Board & General Meetings</div></div>

      <div className="tab-bar">
        {TABS.map(t => <div key={t.id} className={`tab ${tab===t.id?'active':''}`} onClick={()=>setTab(t.id)}>{t.label}</div>)}
      </div>

      {/* REGISTER TAB */}
      {tab === 'register' && (
        <div>
          <button className="topbar-btn btn-primary" style={{marginBottom:16}} onClick={()=>setShowMeetingForm(!showMeetingForm)}>+ Schedule Meeting</button>
          {showMeetingForm && (
            <div className="card" style={{marginBottom:16}}>
              <div className="form-grid">
                <div className="form-group"><label>Meeting Type</label><select value={meetingForm.type} onChange={e=>setMeetingForm({...meetingForm,type:e.target.value})}><option value="board_meeting">Board Meeting</option><option value="agm">AGM</option><option value="egm">EGM</option><option value="committee_meeting">Committee Meeting</option></select></div>
                <div className="form-group"><label>Date</label><input type="date" value={meetingForm.date} onChange={e=>setMeetingForm({...meetingForm,date:e.target.value})} /></div>
                <div className="form-group"><label>Venue</label><input type="text" value={meetingForm.venue} onChange={e=>setMeetingForm({...meetingForm,venue:e.target.value})} placeholder="e.g. Boardroom, HQ Lagos" /></div>
                <div className="form-group"><label>Chair</label><input type="text" value={meetingForm.chair} onChange={e=>setMeetingForm({...meetingForm,chair:e.target.value})} /></div>
              </div>
              <div className="form-actions"><button className="topbar-btn btn-ghost" onClick={()=>setShowMeetingForm(false)}>Cancel</button><button className="topbar-btn btn-primary" onClick={submitMeeting}>Register</button></div>
            </div>
          )}
          <div className="card">
            <div className="card-title">📋 Meeting Register</div>
            {editMode ? (
              <EditableDataTable
                columns={[{key:'ref',label:'Ref'},{key:'type',label:'Type'},{key:'date',label:'Date'},{key:'venue',label:'Venue'},{key:'chair',label:'Chair'},{key:'quorum_status',label:'Quorum'},{key:'resolutions_count',label:'Resolutions'},{key:'minutes_status',label:'Minutes'}]}
                data={meetings}
                editable={true}
                onDataChange={(updated) => setMeetings(updated)}
                renderCell={(row, colKey) => {
                  if (colKey === 'ref') return <span style={{fontWeight:600,color:'var(--mid)',fontSize:11}}>{row.ref}</span>;
                  if (colKey === 'type') return row.type?.replace(/_/g,' ');
                  if (colKey === 'date') return new Date(row.date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'});
                  if (colKey === 'quorum_status') return row.quorum_status ? <span className="badge badge-green">Yes</span> : <span className="badge badge-gray">No</span>;
                  if (colKey === 'minutes_status') return minutesStatusBadge(row.minutes_status);
                  return row[colKey] ?? '-';
                }}
              />
            ) : (
            <table><thead><tr><th>Ref</th><th>Type</th><th>Date</th><th>Venue</th><th>Chair</th><th>Quorum</th><th>Resolutions</th><th>Minutes</th><th>Action</th></tr></thead>
            <tbody>{meetings.map(m => (
              <tr key={m.id}>
                <td style={{fontWeight:600,color:'var(--mid)',fontSize:11}}>{m.ref}</td>
                <td>{m.type?.replace(/_/g,' ')}</td>
                <td>{new Date(m.date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</td>
                <td>{m.venue||'-'}</td>
                <td>{m.chair||'-'}</td>
                <td>{m.quorum_status ? <span className="badge badge-green">Yes</span> : <span className="badge badge-gray">No</span>}</td>
                <td>{m.resolutions_count}</td>
                <td>{minutesStatusBadge(m.minutes_status)}</td>
                <td><button className="sig-btn primary" onClick={()=>{loadResolutions(m.id); setTab('resolution');}}>Resolutions</button></td>
              </tr>
            ))}</tbody></table>
            )}
          </div>
          <SharePointUpload linkedEntityType="meeting" showToast={showToast} />
        </div>
      )}

      {/* RESOLUTION BUILDER TAB */}
      {tab === 'resolution' && (
        <div className="row-2">
          <div className="card">
            <div className="card-title">📜 Resolution Builder</div>
            {!selectedMeeting && <div className="alert alert-blue">Select a meeting from the Register tab first, or choose one below:</div>}
            {!selectedMeeting && (
              <div style={{display:'flex', gap:8, flexWrap:'wrap', marginBottom:16}}>
                {meetings.slice(0,5).map(m => <button key={m.id} className="sig-btn ghost" onClick={()=>loadResolutions(m.id)}>{m.ref}</button>)}
              </div>
            )}
            <div className="form-grid">
              <div className="form-group"><label>Resolution Reference</label><input type="text" value={res.ref} onChange={e=>setRes({...res,ref:e.target.value})} placeholder="e.g. RES-BM-2025-004-01" /></div>
              <div className="form-group"><label>Meeting Type</label><select value={res.mtype} onChange={e=>setRes({...res,mtype:e.target.value})}><option>Board Meeting</option><option>Annual General Meeting (AGM)</option><option>Extraordinary General Meeting (EGM)</option><option>Committee Meeting</option></select></div>
              <div className="form-group"><label>Meeting Date</label><input type="date" value={res.date} onChange={e=>setRes({...res,date:e.target.value})} /></div>
              <div className="form-group"><label>Meeting Venue</label><input type="text" value={res.venue} onChange={e=>setRes({...res,venue:e.target.value})} placeholder="e.g. Boardroom, HQ Lagos" /></div>
              <div className="form-group full"><label>Board Members Present (one per line)</label><textarea value={res.members} onChange={e=>setRes({...res,members:e.target.value})} rows={6} /></div>
              <div className="form-group full"><label>Resolution Title</label><input type="text" value={res.title} onChange={e=>setRes({...res,title:e.target.value})} placeholder="e.g. Approval of 2025 Capital Expenditure Budget" /></div>
              <div className="form-group full"><label>Resolution Body / Recitals</label><textarea value={res.body} onChange={e=>setRes({...res,body:e.target.value})} rows={5} placeholder="WHEREAS the Company requires..." /></div>
              <div className="form-group full"><label>Resolution(s) Passed (number each on a new line)</label><textarea value={res.items} onChange={e=>setRes({...res,items:e.target.value})} rows={4} placeholder="1. That the 2025 Capital Expenditure Budget..." /></div>
              <div className="form-group"><label>Chairman Name</label><input type="text" value={res.chair} onChange={e=>setRes({...res,chair:e.target.value})} /></div>
              <div className="form-group"><label>Company Secretary</label><input type="text" value={res.sec} onChange={e=>setRes({...res,sec:e.target.value})} /></div>
            </div>
            <div className="form-actions">
              <button className="topbar-btn btn-ghost" onClick={()=>setRes({...res,ref:'',title:'',body:'',items:''})}>🗑 Clear</button>
              <button className="topbar-btn btn-ghost" onClick={printResolution}>🖨 Print</button>
              <button className="topbar-btn btn-primary" onClick={saveResolution}>💾 Save Resolution</button>
            </div>
          </div>
          {/* Live Preview */}
          <div>
            <div className="card" style={{fontFamily:'Georgia, serif'}}>
              <div className="card-title" style={{fontFamily:'DM Sans, sans-serif'}}>👁 Live Preview</div>
              <div id="res-preview-content" style={{border:'1px solid var(--border)', borderRadius:8, padding:24, background:'var(--white)', minHeight:400, fontSize:12.5, lineHeight:1.8, color:'#1a1a1a'}}>
                <div style={{textAlign:'center', marginBottom:16}}>
                  <div style={{fontSize:15, fontWeight:700, letterSpacing:.5}}>DESICON ENGINEERING LIMITED</div>
                  <div style={{fontSize:11, color:'#666', marginTop:2}}>RC No. 13549 | 6B Oko-Awo Street, Off Adetokunbo Ademola Str., Opp. Eko Hotel, Victoria Island, Lagos</div>
                  <div style={{margin:'14px 0', borderTop:'2px solid #0A1F44', borderBottom:'1px solid #0A1F44', padding:'6px 0', fontSize:13, fontWeight:700, letterSpacing:1}}>WRITTEN RESOLUTION OF THE {res.mtype.toUpperCase()}</div>
                  {res.ref && <div style={{fontSize:11, color:'#444'}}><strong>Ref:</strong> {res.ref}</div>}
                </div>
                <div style={{marginBottom:10, fontSize:11}}>
                  <span style={{color:'#666'}}>Date:</span> <strong>{formatDate(res.date)}</strong> | <span style={{color:'#666'}}>Venue:</span> <strong>{res.venue || '________________________'}</strong>
                </div>
                {res.members && (
                  <div style={{margin:'10px 0'}}>
                    <div style={{fontSize:11, fontWeight:700, marginBottom:4, textTransform:'uppercase', letterSpacing:.5, color:'#444'}}>Members Present:</div>
                    {res.members.split('\n').filter(Boolean).map((m,i) => <div key={i} style={{padding:'2px 0'}}>{m}</div>)}
                  </div>
                )}
                <div style={{margin:'12px 0', borderTop:'1px solid #ddd'}}></div>
                {res.title && <div style={{fontSize:12, fontWeight:700, textTransform:'uppercase', letterSpacing:.5, marginBottom:8}}>{res.title}</div>}
                {res.body && res.body.split('\n\n').map((p,i) => <p key={i} style={{margin:'8px 0'}}>{p}</p>)}
                {res.items && (
                  <div style={{margin:'10px 0', background:'#EFF6FF', borderLeft:'3px solid #2563EB', padding:'10px 14px', borderRadius:'0 6px 6px 0', fontSize:11.5}}>
                    {res.items.split('\n').filter(Boolean).map((line,i) => <div key={i} style={{padding:'3px 0 3px 8px'}}>{line}</div>)}
                  </div>
                )}
                <div style={{margin:'20px 0', borderTop:'1px solid #ddd'}}></div>
                <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:30, marginTop:16, fontSize:11}}>
                  <div><div style={{borderTop:'1px solid #333', paddingTop:6, marginTop:36}}><strong>{res.chair}</strong></div><div style={{color:'#666'}}>Chairman</div></div>
                  <div><div style={{borderTop:'1px solid #333', paddingTop:6, marginTop:36}}><strong>{res.sec}</strong></div><div style={{color:'#666'}}>Company Secretary</div></div>
                </div>
                {(res.date || res.mtype) && <div style={{textAlign:'center', marginTop:16, fontSize:10, color:'#999'}}>This resolution was duly passed at a {res.mtype} of Desicon Engineering Limited held on {formatDate(res.date)}.</div>}
              </div>
            </div>
            {/* Saved Resolutions */}
            {resolutions.length > 0 && (
              <div className="card" style={{marginTop:16}}>
                <div className="card-title">📋 Saved Resolutions</div>
                <table><thead><tr><th>Ref</th><th>Title</th><th>Status</th></tr></thead>
                <tbody>{resolutions.map(r => (
                  <tr key={r.id}><td style={{fontWeight:600,color:'var(--mid)',fontSize:11}}>{r.ref}</td><td>{r.title}</td><td><span className="badge badge-green">{r.status}</span></td></tr>
                ))}</tbody></table>
              </div>
            )}
          </div>
        </div>
      )}

      {/* MINUTES TAB */}
      {tab === 'minutes' && (
        <div>
          <div className="card">
            <div className="card-title">🗒️ Minutes Repository</div>
            <table><thead><tr><th>Meeting Ref</th><th>Type</th><th>Date</th><th>Chair</th><th>Version</th><th>Status</th></tr></thead>
            <tbody>{meetings.map(m => (
              <tr key={m.id}>
                <td style={{fontWeight:600,color:'var(--mid)',fontSize:11}}>{m.ref}</td>
                <td>{m.type?.replace(/_/g,' ')}</td>
                <td>{new Date(m.date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</td>
                <td>{m.chair}</td>
                <td>{m.minutes_status==='approved'?'Final':'Draft'}</td>
                <td>{minutesStatusBadge(m.minutes_status)}</td>
              </tr>
            ))}</tbody></table>
          </div>
          <SharePointUpload linkedEntityType="minutes" showToast={showToast} />
        </div>
      )}
    </div>
  );
}
